import cn from 'classnames/bind'
import { FieldProps } from 'formik'
import styles from './index.module.css'

const cx = cn.bind(styles)

export const FormikInput = ({ field, form, ...props }: FieldProps) => {
  return <input {...field} {...props} className={cx('input')} />
}
